<template>
  <div class="home-wrap">
    <WebGameBox></WebGameBox>
    <Header></Header>
  </div>
</template>

<script>
import Header from '../components/home/Header.vue'
import WebGameBox from '../components/home/WebGameBox.vue'

export default {
  name: 'Home',
  components: { Header, WebGameBox },
  data () {
    return {}
  }
}
</script>

<style lang="less" scoped>
.home-wrap{
  width: 100%;
  height: 100%;
  position: relative;
  padding-top: @headerH;
}
</style>
